<div class="input-group pacote-campanha-multiselect">
    <div class="input-group-prepend">
        <button class="btn btn-light" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <div class="dropdown-item" onclick="event.stopPropagation()">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [ngModel]="somenteAtivos" (ngModelChange)="toggleSomenteAtivos($event)" [name]="nameSomenteAtivos" [id]="idSomenteAtivos">
                    <label class="custom-control-label" [for]="idSomenteAtivos">Somente Ativos</label>
                </div>
            </div>
        </div>
    </div>
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="idsPacotes"
        (ngModelChange)="onChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>